import React from 'react'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'

const MemberAddressToolTip = () => (
    <CustomToolTip
        type="?"
        info="Enter the best mailing address for your Member. This could be a business address, PO Box, or your home address."
    />
)

export default MemberAddressToolTip
